import InventoryItem from 'src/models/inventory-item/InventoryItem'
import Model, { ID, MODEL_LEVEL } from 'src/models/model'

export default class InventorySupplier extends Model {
  static name = 'InventorySupplier'

  static versioned = true

  static isConfiguration = true

  static level = MODEL_LEVEL.SITE

  static employeeRequiredPermissionCategories = [Model.permissionCategories.Inventory]

  static define () {
    this.fields = {
      id: {
        type: ID
      },
      name: {
        type: String
      },
      inventoryItems: {
        type: [InventoryItem],
        reference: true
      }
    }

    this.paginate = true
  }
}
